

















import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import PredictDataStatisticsNa from '@/trials/views/trials/predict/data/PredictDataStatisticsNa.vue';
import PredictDataStatisticsAll from '@/trials/views/trials/predict/data/PredictDataStatisticsAll.vue';

@Component({ components: { PredictDataStatisticsNa, PredictDataStatisticsAll } })
export default class PredictDataStatistics extends Vue {
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
}
